var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 293,
    viewBox: "0 0 236 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M235.732 146.917C231.629 144.515 228.657 144.45 226.815 146.723C224.974 148.963 224.07 152.761 224.07 158.118V186.979C224.07 192.466 223.553 197.011 222.551 200.615C221.55 204.348 219.838 207.01 217.479 208.569C215.186 210.16 212.084 210.582 208.143 209.835C204.299 209.121 199.485 207.108 193.735 203.764L190.989 202.173V179.447L194.413 181.428C198.516 183.83 201.262 184.122 202.651 182.369C204.105 180.681 204.848 177.142 204.848 171.786V146.365C204.848 139.743 205.494 134.516 206.786 130.652C208.078 126.789 210.631 124.354 214.475 123.25C210.631 117.699 208.078 112.277 206.786 106.953C205.494 101.628 204.88 95.6547 204.88 89.0318V63.6116C204.88 58.2548 204.137 53.9044 202.683 50.4956C201.327 47.1517 198.581 44.2947 194.446 41.8923L191.021 39.9119V17.1863L193.767 18.7771C199.517 22.121 204.331 25.6597 208.175 29.4257C212.117 33.2241 215.218 37.2823 217.512 41.5352C219.902 45.8531 221.582 50.4631 222.583 55.3654C223.585 60.1378 224.102 65.2997 224.102 70.7539V99.6155C224.102 104.972 225.006 109.842 226.848 114.192C228.689 118.575 231.661 121.952 235.764 124.322L235.732 146.917Z",
    fill: "url(#paint0_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M131.547 63.3192C135.65 65.7217 138.622 65.7866 140.463 63.514C142.305 61.2739 143.209 57.4755 143.209 52.1187V23.2572C143.209 17.7705 143.726 13.2254 144.728 9.62177C145.729 5.88826 147.377 3.19365 149.67 1.60285C152.061 0.0445237 155.162 -0.377524 159.007 0.336711C162.948 1.08341 167.794 3.12872 173.544 6.47264L176.29 8.06343V30.7891L172.866 28.8087C168.763 26.4063 165.952 26.0816 164.498 27.7698C163.142 29.5229 162.431 33.0617 162.431 38.4184V63.8387C162.431 70.4616 161.785 75.6885 160.493 79.5518C159.2 83.3828 156.648 85.8501 152.804 86.9539C156.648 92.5055 159.2 97.9272 160.493 103.251C161.785 108.576 162.399 114.549 162.399 121.172V146.593C162.399 151.949 163.077 156.3 164.466 159.644C165.92 163.052 168.73 165.942 172.833 168.312L176.258 170.292V193.018L173.512 191.427C167.761 188.083 162.916 184.512 158.974 180.713C155.13 176.948 152.029 172.922 149.638 168.604C147.344 164.351 145.697 159.773 144.695 154.839C143.694 150.066 143.177 144.904 143.177 139.45V110.589C143.177 105.232 142.272 100.362 140.431 96.0117C138.59 91.6289 135.618 88.2525 131.515 85.8826L131.547 63.3192Z",
    fill: "url(#paint1_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M222.81 156.657C218.707 154.254 215.735 154.189 213.893 156.462C212.052 158.702 211.147 162.501 211.147 167.857V196.719C211.147 202.206 210.631 206.751 209.629 210.354C208.628 214.088 206.915 216.75 204.557 218.308C202.263 219.899 199.162 220.321 195.221 219.574C191.377 218.86 186.563 216.847 180.813 213.503L178.067 211.913V189.187L181.491 191.167C185.594 193.57 188.34 193.862 189.729 192.109C191.183 190.421 191.926 186.882 191.926 181.525V156.105C191.926 149.482 192.572 144.255 193.864 140.392C195.156 136.528 197.708 134.093 201.553 132.99C197.708 127.438 195.156 122.016 193.864 116.692C192.572 111.368 191.958 105.394 191.958 98.7713V73.3511C191.958 67.9943 191.215 63.644 189.761 60.2351C188.404 56.8912 185.659 54.0342 181.523 51.6318L178.099 49.6514V26.9258L180.845 28.5166C186.595 31.8605 191.409 35.3992 195.253 39.1652C199.194 42.9636 202.296 47.0218 204.589 51.2747C206.98 55.5926 208.66 60.2026 209.661 65.1049C210.663 69.8773 211.18 75.0392 211.18 80.4934V109.355C211.18 114.712 212.084 119.582 213.926 123.932C215.767 128.315 218.739 131.691 222.842 134.061L222.81 156.657Z",
    fill: "url(#paint2_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M118.625 73.0587C122.728 75.4612 125.7 75.5261 127.541 73.2535C129.383 71.0134 130.287 67.215 130.287 61.8582V32.9967C130.287 27.51 130.804 22.9649 131.806 19.3613C132.807 15.6278 134.455 12.9332 136.748 11.3424C139.139 9.78403 142.24 9.36198 146.084 10.0762C150.026 10.8229 154.871 12.8682 160.622 16.2121L163.368 17.8029V40.5286L159.943 38.5482C155.841 36.1458 153.03 35.8211 151.576 37.5093C150.22 39.2624 149.509 42.8012 149.509 48.1579V73.5782C149.509 80.2011 148.863 85.428 147.57 89.2914C146.278 93.1223 143.726 95.5896 139.882 96.6934C143.726 102.245 146.278 107.667 147.57 112.991C148.863 118.315 149.477 124.289 149.477 130.912V156.332C149.477 161.689 150.155 166.039 151.544 169.383C152.998 172.792 155.808 175.681 159.911 178.051L163.335 180.032V202.757L160.59 201.167C154.839 197.823 149.993 194.251 146.052 190.453C142.208 186.687 139.107 182.661 136.716 178.343C134.422 174.091 132.775 169.513 131.773 164.578C130.772 159.806 130.255 154.644 130.255 149.19V120.328C130.255 114.971 129.35 110.102 127.509 105.751C125.668 101.368 122.695 97.992 118.593 95.6221L118.625 73.0587Z",
    fill: "url(#paint3_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M46.9074 3.9729L102.117 36.0161L102.085 168.896L46.8751 136.853L46.9074 3.9729Z",
    fill: "url(#paint4_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5374 24.3936L80.4402 49.8788V62.1181L36.5374 36.6329V24.3936Z",
    fill: "#5F27BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M53.7238 77.5066L95.9145 101.985V121.01L53.7238 96.5312V77.5066Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M53.6913 54.4888L95.9466 79V83.4153L53.6913 58.9365V54.4888Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M53.6913 63.1245L90.2286 84.3243V88.7396L53.6913 67.5398V63.1245Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.9072 3.9729L102.117 36.0161V53.8395L46.9072 21.7963V3.9729Z",
    fill: "url(#paint5_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.7015 20.9846C60.7015 23.6792 59.1186 24.9454 57.1803 23.8416C55.2419 22.7053 53.6913 19.6211 53.6913 16.9265C53.6913 14.2318 55.2742 12.9657 57.2126 14.0695C59.1186 15.2058 60.7015 18.29 60.7015 20.9846Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M114.748 127.178L169.958 159.221L169.926 292.102L114.716 260.058L114.748 127.178Z",
    fill: "url(#paint6_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.779 165.844L179.682 191.297V203.504L135.747 178.051L135.779 165.844Z",
    fill: "url(#paint7_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M121.565 178.473L163.788 202.985V221.977L121.565 197.466V178.473Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M121.5 205.615L163.756 230.126V234.541L121.5 210.062V205.615Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M121.5 213.601L158.038 234.801V239.216L121.5 218.016V213.601Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.748 127.178L169.958 159.221V177.045L114.748 145.002V127.178Z",
    fill: "url(#paint8_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.543 144.223C128.543 146.917 126.96 148.183 125.021 147.08C123.083 145.943 121.532 142.859 121.532 140.165C121.532 137.47 123.115 136.204 125.054 137.308C126.96 138.411 128.543 141.528 128.543 144.223Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M105.186 145.586L9.07776 89.8433L9.11006 140.197L96.7543 191.037L105.251 203.666L105.186 145.586Z",
    fill: "url(#paint9_linear_437_2569)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80.4723 143.508L59.4093 131.302V135.717L80.4723 147.924V143.508Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80.4725 152.371L28.3318 122.114V126.529L80.5048 156.787L80.4725 152.371Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80.5047 161.234L17.5417 124.711V129.126L80.5047 165.65V161.234Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6737 151.138C85.6737 155.293 88.1289 160.066 91.1333 161.819C94.1377 163.572 96.5929 161.624 96.5929 157.468C96.5929 153.313 94.1377 148.54 91.1333 146.787C88.0966 145.034 85.6737 146.982 85.6737 151.138Z",
    fill: "#D171CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.5756 54.4887L5.84729 47.0867V42.7688L18.5756 50.1709C19.6093 50.7877 21.1277 51.9889 22.4199 53.8719C23.809 55.8847 24.8105 58.417 24.8105 61.1766C24.8105 64.2283 24.0352 65.949 22.5814 66.4684C21.1923 66.9229 19.577 66.1438 18.5756 65.5594L13.3421 62.5077L13.3098 62.4752C12.8575 62.2155 12.1468 61.9557 11.5976 62.1181C11.1454 62.2479 10.5962 62.7349 10.5962 64.4231C10.5962 66.1113 11.1131 67.1502 11.5653 67.767C12.1145 68.5462 12.8252 69.0981 13.2775 69.3254L13.3421 69.3578L29.3655 78.6429V82.9608L13.439 73.7082C12.3407 73.1238 10.7577 71.9226 9.40087 70.0071C7.91483 67.8969 6.88106 65.2347 6.88106 62.2479C6.88106 59.2936 7.91483 57.7677 9.36857 57.3457C10.7254 56.9561 12.3083 57.5405 13.4067 58.1898L18.6079 61.209C19.3509 61.6311 19.9324 61.8259 20.2878 61.696C20.5785 61.5986 21.0954 61.1766 21.0954 59.0014C21.0954 57.5729 20.6431 56.6639 20.1908 56.0146C19.674 55.3004 18.9955 54.716 18.5756 54.4887Z",
    fill: "#EEF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62698 47.541C9.62698 51.242 7.46252 52.9627 4.81349 51.4368C2.16445 49.911 0 45.658 0 41.957C0 38.256 2.16445 36.5353 4.81349 38.0612C7.46252 39.6195 9.62698 43.8724 9.62698 47.541ZM35.1481 83.2528C35.1481 86.9538 32.9837 88.6744 30.3347 87.1486C27.6856 85.6227 25.5212 81.3698 25.5212 77.6687C25.5212 73.9677 27.6856 72.247 30.3347 73.7729C32.9837 75.3312 35.1481 79.5842 35.1481 83.2528Z",
    fill: "#46F3B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.4886 196.134C71.4269 197.271 72.9776 199.965 72.9776 202.238V212.14L79.5032 215.906C81.4415 217.042 82.9922 219.737 82.9922 222.009C82.9922 224.249 81.4092 225.158 79.5032 224.055L72.9776 220.289V230.19C72.9776 232.431 71.3946 233.34 69.4886 232.236C67.5503 231.099 65.9996 228.405 65.9996 226.132V216.23L59.474 212.464C57.5356 211.328 55.985 208.634 55.985 206.361C55.985 204.121 57.5679 203.212 59.474 204.316L65.9996 208.082V198.18C65.9996 195.907 67.5503 194.998 69.4886 196.134Z",
    fill: "url(#paint10_linear_437_2569)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_437_2569",
    x1: 2661.68,
    y1: 673.022,
    x2: -3470.55,
    y2: 11248.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_437_2569",
    x1: 2717.19,
    y1: 93.2276,
    x2: -3413.85,
    y2: 10666.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_437_2569",
    x1: 2648.76,
    y1: 682.762,
    x2: -3483.47,
    y2: 11258.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_437_2569",
    x1: 2704.27,
    y1: 102.967,
    x2: -3426.78,
    y2: 10676.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_437_2569",
    x1: 3133.41,
    y1: 3265.17,
    x2: -1002.84,
    y2: 10395.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_437_2569",
    x1: 1941.82,
    y1: 504.933,
    x2: 3347.17,
    y2: 4469.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_437_2569",
    x1: 3201.25,
    y1: 3388.21,
    x2: -935.029,
    y2: 10518.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_437_2569",
    x1: 157.714,
    y1: 165.844,
    x2: 157.714,
    y2: 203.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46F3B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_437_2569",
    x1: 2009.88,
    y1: 628.686,
    x2: 3415.23,
    y2: 4593.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_437_2569",
    x1: 6769.93,
    y1: 3650.46,
    x2: 2649.42,
    y2: 6860.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_437_2569",
    x1: 1768.92,
    y1: 1512.23,
    x2: 556.081,
    y2: 2464.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHero);
export default __webpack_public_path__ + "static/media/img_hero.7ace6b563bdae21be51a4aa59ded3ca5.svg";
export { ForwardRef as ReactComponent };